import request from '@/utils/request'

//新闻公告查询前台用
export function icAnnouncesList1(query) {
    return request({
        url: '/icAnnounces/list1',
        method: 'get',
        params: query
    })
}

//新闻公告查询前台用(不分页)
export function getIcAnnouncesList(query) {
    return request({
        url: '/icAnnounces/getIcAnnouncesList',
        method: 'get',
        params: query
    })
}

//新闻公告查看放大镜和编辑查询接口
export function icAnnouncesView(query) {
    return request({
        url: '/icAnnounces/view',
        method: 'get',
        params: query
    })
}
